// extracted by mini-css-extract-plugin
export default {"element":"tip_element__mGdZ8","flag":"tip_flag__8yy5j"};